//images
import payment_1 from '../../../assets/images/FormasDePago/visa_2.png';
import payment_2 from '../../../assets/images/FormasDePago/mastercard_2.png';
import payment_3 from '../../../assets/images/FormasDePago/mercado-pago_2.png';
import payment_4 from '../../../assets/images/FormasDePago/Paypal_2.png';
import payment_5 from '../../../assets/images/FormasDePago/oxxo_2.png';

import { Typography, Box } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { FREE_SHIPPING_THRESHOLD } from '../../../constants/shop/shop_constants';

// const productsFS = ['Rensensitive HP 1.2 kg', 'Rensensitive LP 1.2 kg Vainilla', 'Rensensitive LP 1.2 kg Plátano Fresa', 'Rensensitive LP 1.2 kg Mango', '60 capsulas - Antes Simbin RNL'];

const PaymentInfo = ({ title, variant_title, freeShipping }) => {
    return (
        <>
            <Box sx={{ mt: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
                    <Box sx={{ my: 'auto' }}>
                        <LocalShippingIcon sx={{ color: '#5552B2' }} />
                    </Box>
                    <Box sx={{ my: 'auto' }}>
                        <Typography variant='body2'>
                            <span style={{ fontWeight: 'bold', color: '#5552B2' }}>Envío gratis</span>
                            {
                                // (productsFS.includes(title) || productsFS.includes(variant_title))
                                // ? 'Este producto contiene envio gratis'
                                // : `En compras mayores a $${FREE_SHIPPING_THRESHOLD.toLocaleString('es-MX')}`
                                freeShipping
                                ? ': Este producto contiene envío gratis'
                                : `. En compras mayores a $${FREE_SHIPPING_THRESHOLD.toLocaleString('es-MX')}`
                            }
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '10px', mt: 3 }}>
                    <Box sx={{ my: 'auto' }}>
                        <CreditCardIcon sx={{ color: '#5552B2' }} />
                    </Box>
                    <Box sx={{ my: 'auto' }}>
                        <Typography variant='body2'>
                            <span style={{ fontWeight: 'bold', color: '#5552B2' }}>
                            Paga en linea y recibe en casa.</span> Todos los medios de pago
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '10px', mt: 3 }}>
                    <Box sx={{ my: 'auto' }}>
                        <LockIcon sx={{ color: '#5552B2' }} />
                    </Box>
                    <Box sx={{ my: 'auto' }}>
                        <Typography variant='body2'>
                            <span style={{ fontWeight: 'bold', color: '#5552B2' }}>Compras Seguras.</span> Compras protegidas siempre
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Box sx={{ mt: 3 }}>
                <Typography variant='body1' sx={{ fontWeight: '600' }} paragraph>Métodos de pago</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '15px', flexWrap: 'wrap' }}>
                    <Box>
                        <img src={payment_1} alt={payment_1} width='80' />
                    </Box>

                    <Box>
                        <img src={payment_2} alt={payment_2} width='80' />
                    </Box>

                    <Box>
                        <img src={payment_3} alt={payment_3} width='80' />
                    </Box>

                    <Box>
                        <img src={payment_4} alt={payment_4} width='80' />
                    </Box>

                    <Box>
                        <img src={payment_5} alt={payment_5} width='80' />
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default PaymentInfo;
